import { useQuery } from "@apollo/client";
import { Check, X, AlertTriangle } from "tabler-icons-react";
import { RECENT_WAVE_EVENTS } from "../queries/waves";

const ERROR_TYPES = new Set([
    "RANDOMIZER_ERROR", "RANDOMIZER_SKIP",
    "SESSION_ERROR", "SESSION_OPEN_SKIP", "SESSION_CLOSE_SKIP",
    "FLAG_ERROR",
]);

function Issue({ level, text }) {
    const color = level === "error" ? "crimson" : "#b45309";
    const Icon = level === "error" ? X : AlertTriangle;
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", color }}>
            <Icon size={16} />
            <span style={{ fontSize: 14 }}>{text}</span>
        </div>
    );
}

export default function WaveHealthTile({ waveId, wave, currentFlags }) {
    const { data, loading, error } = useQuery(RECENT_WAVE_EVENTS, {
        variables: { waveId, limit: 500 },
        pollInterval: 30000,
    });

    const issues = [];

    if (!loading && data) {
        const events = data.recentWaveEvents || [];

        const errorEvents = events.filter(e => ERROR_TYPES.has(e.type));
        if (errorEvents.length > 0) {
            issues.push({ level: "error", text: `${errorEvents.length} error event(s) logged, check monitor for details` });
        }

        const hasSessionOpen = events.some(e => e.type === "SESSION_OPEN");
        if (wave.current_phase >= 2 && !hasSessionOpen) {
            issues.push({ level: "warn", text: "Phase 2+ active but no SESSION_OPEN event seen, scheduler may not have run" });
        }

        if (wave.current_phase >= 2 && currentFlags.length === 0) {
            issues.push({ level: "warn", text: "No flags set in Phase 2+, dark pattern may not be active" });
        }

        const randomizerRan = events.some(e => e.type === "RANDOMIZER_RUN" || e.type === "ARM_ASSIGNED");
        if (wave.current_phase === 3 && !randomizerRan) {
            issues.push({ level: "warn", text: "Phase 3 active but no RANDOMIZER_RUN event, arms may not be assigned" });
        }
    }

    return (
        <div className="admin-section">
            <h3>Wave health</h3>
            {loading && <p style={{ color: "#888" }}>Checking</p>}
            {error && <p style={{ color: "crimson" }}>Could not load health data: {error.message}</p>}
            {!loading && !error && issues.length === 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#16a34a" }}>
                    <Check size={18} />
                    <span>All clear, no issues detected.</span>
                </div>
            )}
            {issues.map((iss, i) => <Issue key={i} level={iss.level} text={iss.text} />)}
            <p style={{ color: "#aaa", fontSize: 12, marginTop: 12 }}>Auto-refreshes every 30s.</p>
        </div>
    );
}
